import './common/BackLayout/BackLayout.css';
import './common/FrontLayout/FrontLayout.css';
import './CropPageView.css';

import * as React from 'react';
import { connect } from 'react-redux';

import {
  dragNDropProduct,
  moveCrop,
  onPageOrSpreadSelect,
  removeProduct,
  saveDocument,
  updateBrandings,
  onMovePlaceholders,
} from '../../../../actions/actions';
import { placeOrder } from '../../../../actions/orderActions';
import { IDocument, IEditorState, IPage, IPlaceHolder, ISpread, IDragInfo, IOrderQuantities_Addresses } from '../../../../infrastructure/interfaces';
import { productType } from '../../../../infrastructure/ProductType';
import DragTypes from '../../../../infrastructure/DragTypes';
import { IWizardState } from '../../../Wizard/Wizard';
import BrochureContainer from './Brochure/BrochureContainer';
import CatalogContainer from './Catalog/CatalogContainer';
import BulletinContainer from './Bulletin/BulletinContainer';
import PostcardContainer from './Postcard/PostcardContainer';
import PosterContainer from './Poster/PosterContainer';

export interface ICropPageProps {
  wizard?: IWizardState;
  document?: IDocument;
  editor?: IEditorState;
  dragNDropProduct?(data: any): void;
  removeProduct(data: any): void;
  moveCrop?(dragIndex: number, hoverIndex: number): void;
  onMovePlaceholders?(data: any): void;
}
export interface ICropPageState {
}

const mapStateToProps = (state: any): any => {
  return {
    wizard: state.wizard,
    document: state.document,
    editor: state.editor,
  };
};
const mapDispatchToProps = (dispatch: any): any => {
  return {
    saveDocument: (document: IDocument, userID: string, redirect?: string) => {
      dispatch(saveDocument(document, userID, redirect));
    },
    placeOrder: (document: IDocument, userID: string, user_email: string, username: string, comments: string, orderQuantitiesAddresses: IOrderQuantities_Addresses[]) => {
      dispatch(placeOrder(document, userID, user_email, username, comments, orderQuantitiesAddresses));
    },
    moveCrop: (dragIndex: number, hoverIndex: number) => {
      dispatch(moveCrop(dragIndex, hoverIndex));
    },
    updateBrandings: (brandings: any) => {
      dispatch(updateBrandings(brandings));
    },
    dragNDropProduct: (data: any) => {
      dispatch(dragNDropProduct(data));
    },
    removeProduct: (data: any) => {
      dispatch(removeProduct(data));
    },
    onSpreadSelect: (spread: ISpread): void => {
      dispatch(onPageOrSpreadSelect(spread));
    },
    onPageSelect: (page: IPage): void => {
      dispatch(onPageOrSpreadSelect(page));
    },
    onMovePlaceholders: (data: any) => {
      dispatch(onMovePlaceholders(data));
    },
  };
};

@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class CropPageView extends React.Component<ICropPageProps, ICropPageState> {
  handleDrop = (index: number, data: IPlaceHolder, dragInfo: IDragInfo) => {
    const model = {
      type: this.getProductType(),
      spread: (this.props.editor) ? this.props.editor.selectedSpread : null,
      page: (this.props.editor) ? this.props.editor.selectedPage : null,
      index,
      model: data,
      dragInfo,
    };

    if (dragInfo.type === DragTypes.PLACEHOLDERS) {
      if (this.props.onMovePlaceholders != undefined) {
        this.props.onMovePlaceholders(model);
      }
    } else {
      if (this.props.dragNDropProduct != undefined) {
        this.props.dragNDropProduct(model);
      }
    }

  }

  moveCrop = (dragIndex: number, hoverIndex: number) => {
    if (this.props.moveCrop != undefined) {
      this.props.moveCrop(dragIndex, hoverIndex);
    }
  }
  removeProduct = (e: any, index: number) => {
    const data = {
      type: this.getProductType(),
      spread: (this.props.editor) ? this.props.editor.selectedSpread : null,
      page: (this.props.editor) ? this.props.editor.selectedPage : null,
      index,
    };

    this.props.removeProduct(data);

    e.preventDefault();
  }

  getProductType(): string {
    return (this.props.document) ? this.props.document.type : productType.Bulletin;
  }

  renderPlaceholders(isSpreadView: boolean, selectedPage: IPage | null, selectedSpread: ISpread | null) {
    if (isSpreadView) {
      return this.renderSpread(selectedSpread);
    }
    return this.renderSingle(selectedPage);
  }

  renderSingle(selectedPage: IPage | null) {

    if (selectedPage == null) {
      return (<div></div>);
    }
    const type = this.getProductType();
    switch (type) {
      case productType.Brochure:
        {
          return (
            <BrochureContainer
              handleDrop={this.handleDrop}
              removeProduct={this.removeProduct}
              moveCrop={this.moveCrop}
              document={this.props.document ? this.props.document : null}
            />
          );
        }
      case productType.Catalog:
        {
          return (
            <CatalogContainer
              handleDrop={this.handleDrop}
              removeProduct={this.removeProduct}
              moveCrop={this.moveCrop}
              document={this.props.document ? this.props.document : null}
              pageToRender={selectedPage}
              isSpreadView={false}
              disclaimers={this.props.wizard!.disclaimers}
              isEditorRendering={true}
            />
          );
        }
      case productType.Bulletin:
        {
          return (
            <BulletinContainer
              handleDrop={this.handleDrop}
              removeProduct={this.removeProduct}
              moveCrop={this.moveCrop}
              document={this.props.document ? this.props.document : null}
              disclaimers={this.props.wizard!.disclaimers}
              page={selectedPage}
              isEditorRendering={true}
            />
          );
        }
        case productType.Poster:
          {
            return (
              <PosterContainer
                handleDrop={this.handleDrop}
                removeProduct={this.removeProduct}
                moveCrop={this.moveCrop}
                document={this.props.document ? this.props.document : null}
                spread={this.props.editor!.selectedSpread!}
                disclaimers={this.props.wizard!.disclaimers}
                isPDFRender={false}
              />
            );
          }
      default:
        return (
          <div></div>
        );
    }
  }

  renderSpread(spread: ISpread | null) {
    if (spread == null) {
      return (<div></div>);
    }
    const type = this.getProductType();
    switch (type) {
      case productType.Brochure:
        {
          return (
            <BrochureContainer
              handleDrop={this.handleDrop}
              removeProduct={this.removeProduct}
              moveCrop={this.moveCrop}
              document={this.props.document ? this.props.document : null}
            />
          );
        }
      case productType.Catalog:
        {
          return (
            <CatalogContainer
              handleDrop={this.handleDrop}
              removeProduct={this.removeProduct}
              moveCrop={this.moveCrop}
              document={this.props.document ? this.props.document : null}
              spreadToRender={spread}
              isSpreadView={true}
              disclaimers={this.props.wizard!.disclaimers}
              isEditorRendering={true}
            />
          );
        }
      case productType.Bulletin:
        {
          return (
            <BulletinContainer
              handleDrop={this.handleDrop}
              removeProduct={this.removeProduct}
              moveCrop={this.moveCrop}
              document={this.props.document ? this.props.document : null}
              disclaimers={this.props.wizard!.disclaimers}
              page={spread.left}
              isEditorRendering={true}
            />
          );
        }
      case productType.Postcard:
        {
          return (
            <PostcardContainer
              handleDrop={this.handleDrop}
              removeProduct={this.removeProduct}
              moveCrop={this.moveCrop}
              spread={spread}
              document={this.props.document ? this.props.document : null}
              disclaimers={this.props.wizard!.disclaimers}
              isPDFRender={false}
            />
          );
        }
      case productType.Poster:
        {
          return (
            <PosterContainer
              handleDrop={this.handleDrop}
              removeProduct={this.removeProduct}
              moveCrop={this.moveCrop}
              document={this.props.document ? this.props.document : null}
              spread={spread}
              disclaimers={this.props.wizard!.disclaimers}
              isPDFRender={false}
            />
          );
        }
      default:
        return (
          <div></div>
        );
    }
  }

  render() {
    const productType = this.getProductType();
    const isSpreadView = ((productType === "Catalog") || (productType === "Postcard") || (productType === "Poster"));
    const selectedSpread = (this.props.editor != undefined) ? this.props.editor.selectedSpread : null;
    const selectedPage = (this.props.editor != undefined) ? this.props.editor.selectedPage : null;
    const rightPageExists = (selectedSpread != null);
    const zoomNumber: number = (this.props.editor != null) ? (this.props.editor.zoomLevel/100) : 1;

    if(productType === "Catalog"){
      return (
        <div className="product-container-wrap">
          <div className={`crop-page-box`}>
            <div
              className={`crop-page-view ${isSpreadView && !rightPageExists ? ' half-width' : ''}`}
              style={{transform: `scale(${zoomNumber})`}}
            >
              {this.renderPlaceholders(isSpreadView, selectedPage, selectedSpread)}
            </div>
          </div>
        </div>
      );
    }
    if(productType === "Postcard"){
      return (
        <div className="product-container-wrap">
          <div className={`crop-page-box ${productType}`}>
            <div
              className={`crop-page-view ${productType}`}
              style={{transform: `scale(${zoomNumber})`}}
            >
              {this.renderPlaceholders(isSpreadView, selectedPage, selectedSpread)}
            </div>
          </div>
        </div>
      );
    }
    else{
    return (
      <div className="product-container-wrap">
        <div className={`crop-page-box ${productType}`}>
          <div
            className={`crop-page-view ${productType}`}
            style={{transform: `scale(${zoomNumber})`}}
          >
            {this.renderPlaceholders(isSpreadView, selectedPage, selectedSpread)}
          </div>
        </div>
      </div>
    );
  }
 }
}



// WEBPACK FOOTER //
// ./src/components/Editor/components/CropPageView/CropPageView.tsx